export function MenuInner() {
    return (
        <>
            {/*Not used but maybe in the future*/}
            {/*<MenuItem title={"example"} to='/Example'/>*/}
        </>
    )
}
